module.exports = __webpack_public_path__ + "img/onetouch.d7d5c216.svg";